<span *ngIf="plantTypeInfo$|async as plantTypeInfos; else loading" >
      <img [src]="plantTypeInfos.iconURI" alt="Icon" class="image"> {{plantTypeInfos.key}}
</span>

<ng-template #loading >
      <mat-spinner [diameter]="30" ></mat-spinner>
</ng-template>